import React from 'react';

const H1: React.CSSProperties = { fontSize: 26, fontWeight: 800, margin: '0 0 6px', color: '#0E1A1A' };
const SUB: React.CSSProperties = { margin: 0, fontSize: 14, color: '#66748B', maxWidth: 560 };
const PAGE_HEAD: React.CSSProperties = {
  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
  gap: 24, marginBottom: 22,
};
const BTN: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  background: '#0E1A1A', color: '#FFFFFF',
  fontSize: 14, fontWeight: 600, padding: '11px 18px',
  borderRadius: 10, border: 0, cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(14,26,26,.12)',
};
const BTN_GHOST: React.CSSProperties = {
  ...BTN, background: '#FFFFFF', color: '#0E1A1A',
  border: '1px solid #E7EAF0', boxShadow: 'none',
};
const TOOLBAR: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  background: '#FFFFFF', border: '1px solid #E7EAF0',
  borderRadius: '14px 14px 0 0', padding: '12px 18px', borderBottom: 0,
};
const CHIP: React.CSSProperties = {
  fontSize: 12.5, padding: '6px 12px', borderRadius: 999,
  color: '#66748B', background: '#F7F8FA', cursor: 'pointer',
};
const CHIP_ACTIVE: React.CSSProperties = {
  ...CHIP, background: '#0E1A1A', color: '#FFFFFF', fontWeight: 600,
};
const EMPTY_CARD: React.CSSProperties = {
  background: '#FFFFFF', border: '1px solid #E7EAF0', borderTop: 0,
  borderRadius: '0 0 14px 14px',
  display: 'flex', alignItems: 'stretch', overflow: 'hidden',
};
const ILL_WRAP: React.CSSProperties = {
  flex: '0 0 auto',
  width: 300,
  padding: '48px 20px',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: '#FFFFFF',
};
const COPY: React.CSSProperties = {
  flex: 1,
  padding: '52px 48px 60px',
  background: '#FFF8E6',
  display: 'flex', flexDirection: 'column', justifyContent: 'center',
};
const COPY_H2: React.CSSProperties = { fontSize: 30, fontWeight: 800, margin: '0 0 14px', lineHeight: 1.15 };
const COPY_P: React.CSSProperties = { fontSize: 15, color: '#66748B', lineHeight: 1.65, margin: '0 0 22px' };

export default function Products() {
  return (
    <div>
      <div style={PAGE_HEAD}>
        <div>
          <h1 style={H1}>Products &amp; services</h1>
          <p style={SUB}>Save the things you sell so invoices and payment links fill themselves in.</p>
        </div>
        <button type="button" style={BTN}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M12 5v14M5 12h14" />
          </svg>
          New product
        </button>
      </div>

      <div style={TOOLBAR}>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={CHIP_ACTIVE}>All</div>
          <div style={CHIP}>Products</div>
          <div style={CHIP}>Services</div>
        </div>
      </div>

      <div style={EMPTY_CARD}>
        <div style={ILL_WRAP}>
          <svg viewBox="0 0 300 300" width="100%" height="100%" aria-hidden="true">
            <circle cx="150" cy="160" r="130" fill="#FFEFD5"/>
            <circle cx="60" cy="60" r="22" fill="#FFE0A3" opacity="0.7"/>
            <circle cx="245" cy="80" r="16" fill="#FFE0A3" opacity="0.8"/>

            <g transform="translate(90, 80)">
              <rect x="0" y="70" width="120" height="90" rx="4" fill="#F59E0B"/>
              <path d="M 0 70 L 60 50 L 120 70 L 120 72 L 60 92 L 0 72 Z" fill="#FBBF24"/>
              <rect x="30" y="105" width="60" height="14" rx="2" fill="#78350F" opacity="0.7"/>
              <text x="60" y="115" textAnchor="middle" fontSize="9" fontWeight="800" fill="#FFFBEB">PRODUCT</text>
            </g>

            <g transform="translate(45, 160)">
              <rect x="0" y="0" width="80" height="60" rx="4" fill="#15A08C"/>
              <path d="M 0 0 L 40 -15 L 80 0 L 80 2 L 40 17 L 0 2 Z" fill="#2DD4BF"/>
              <rect x="20" y="25" width="40" height="10" rx="2" fill="#0F6E56" opacity="0.7"/>
              <text x="40" y="33" textAnchor="middle" fontSize="7" fontWeight="800" fill="#DCFCE7">SERVICE</text>
            </g>

            <g transform="translate(180, 165)">
              <rect x="0" y="0" width="80" height="60" rx="4" fill="#8B5CF6"/>
              <path d="M 0 0 L 40 -15 L 80 0 L 80 2 L 40 17 L 0 2 Z" fill="#A78BFA"/>
              <rect x="20" y="25" width="40" height="10" rx="2" fill="#4C1D95" opacity="0.7"/>
              <text x="40" y="33" textAnchor="middle" fontSize="7" fontWeight="800" fill="#F3E8FF">BUNDLE</text>
            </g>

            <g transform="translate(220, 55)">
              <circle r="18" fill="#FFFFFF" stroke="#E7EAF0" strokeWidth="1.5"/>
              <text y="4" textAnchor="middle" fontSize="13" fontWeight="800" fill="#15A08C">$</text>
            </g>

            <ellipse cx="150" cy="238" rx="110" ry="5" fill="#0F172A" opacity="0.1"/>
          </svg>
        </div>
        <div style={COPY}>
          <h2 style={COPY_H2}>Save what you sell.</h2>
          <p style={COPY_P}>
            Add a product once with its price and tax. Next time you make an invoice or payment link, pick it from a list, no retyping.
          </p>
          <ul style={{ paddingLeft: 20, color: '#0E1A1A', fontSize: 13.5, lineHeight: 1.7, margin: '0 0 24px' }}>
            <li><b>Products</b>, physical items you ship or hand off</li>
            <li><b>Services</b>, hours, visits, consults, retainers</li>
            <li><b>Bundles</b>, grouped items at one price</li>
          </ul>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button type="button" style={BTN}>New product</button>
            <button type="button" style={BTN_GHOST}>Import from CSV</button>
          </div>
        </div>
      </div>
    </div>
  );
}